export default __webpack_public_path__ + "static/Card6-6a2b71199d5281c7fd183bb9a4ea7f00.png";